const Errors = {
    NO_USER_LOGGED_IN: {
        errorCode: 1,
        errorMessage: "No user is logged in" 
    }
}

module.exports = {Errors};
